<template>
  <div class="message-editor border rounded p-3">
    <mypage-message-title
      :title-key="titleKey"
    />
    <mypage-message-notice
      :setting-key="settingKey"
    />
    <div>
      <b-tabs>
        <b-tab
          v-for="(lang, index) in languages"
          :key="`lang_${settingKey}_${index}`"
          :title="$languages[lang.code]"
          :active="languageData === lang.code"
          @click="() => showMessageText(lang.code)"
        />
      </b-tabs>
    </div>
    <div class="px-3 pt-3 pb-1 border rounded-bottom editor-container">
      <b-form-textarea
        v-model="messageText"
        class="form-control"
        rows="5"
        :state="messageText.length <= 1000 ? null : false"
      />
      <div class="d-flex pt-2 pb-1 justify-content-between">
        <div class="editor-footnote">
          <small>{{ messageText.length }} / 1000</small>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12" align="right">
        <button
          type="button"
          class="btn btn-warning btn-wide"
          :disabled="messageText.length > 1000"
          @click="submitForm"
        >
          <i class="fas fa-save mr-1"></i>
          {{ $t("dashboard-common.word-save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import settingsApi from "@/api/settings";
import MypageMessageNotice from "./MypageMessageNotice";
import MypageMessageTitle from "./MypageMessageTitle";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    MypageMessageNotice,
    MypageMessageTitle
  },
  props: {
    selectedLanguage: {
      type: String,
      default: "ja"
    },
    settingKey: {
      type: String,
      required: true
    },
    titleKey: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(["languages"]),
    ...mapGetters("dashboard", ["facility"])
  },
  data() {
    return {
      data: {
        facility_id: null,
        name: "",
        value: ""
      },
      languageData: "ja",
      messageText: ""
    };
  },
  beforeMount() {
    this.data.facility_id = this.facility.id;
  },
  mounted() {
    this.showMessageText(this.selectedLanguage || "ja");
  },
  methods: {
    async showMessageText(lang) {
      try {
        this.languageData = lang;
        this.$emit("change-language", lang);
        const response = await settingsApi.getMyPageSetting(
          this.facility.id,
          this.settingKey,
          lang
        );
        const data = {
          facility_id: this.facility.id,
          name: `mypage-${this.settingKey}-${lang}`,
          value: response.data[0] ? response.data[0].value : ""
        };
        if (lang !== this.languageData) return;
        this.data = data;
        this.messageText = data.value;
      } catch (e) {
        console.error(e.message);
        this.$toast.error(this.$t("dashboard-common.error-generic"), {
          position: "top"
        });
      }
    },
    async submitForm() {
      try {
        await settingsApi.save(this.data);
        this.$toast.success(this.$t("dashboard-common.updated-generic"), {
          position: "top"
        });
      } catch (e) {
        console.error(e);
        this.$toast.error(this.$t("dashboard-common.error-generic"), {
          position: "top"
        });
      }
    }
  },
  watch: {
    messageText(v) {
      this.data.value = v;
    }
  }
};
</script>

<style lang="scss" scoped>
.message-editor {
  background-color: #fff;
}

.editor-footnote {
  line-height: 31px;
}
</style>
